module.exports = __webpack_public_path__ + "static/media/ChatBot_icon.5db9e799.svg";